import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useEmployerId from '../hooks/useEmployerId'

/**
 * LegacyRedirect component
 * Redirects from legacy routes (without employerId) to new dynamic routes
 * Uses useEmployerId hook to get the current user's employer ID
 */
export default function LegacyRedirect() {
  const employerId = useEmployerId()
  const location = useLocation()
  
  // If no employerId available (admin without selection), redirect to employers list
  if (!employerId) {
    return <Navigate to="/employers" replace />
  }
  
  // Build the new path with employerId prefix
  // Legacy: /calculations/123/timesheets/456
  // New:    /employers/1/calculations/123/timesheets/456
  
  // Get the path after /calculations (or just /calculations if no more path)
  const pathAfterCalculations = location.pathname.replace(/^\/calculations/, '')
  const newPath = `/employers/${employerId}/calculations${pathAfterCalculations}`
  
  // Preserve query string if any
  const search = location.search || ''
  
  return <Navigate to={`${newPath}${search}`} replace />
}
